import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import localStorage from 'localStorage'
import { ImFilePdf } from 'react-icons/im'
import { Form, Modal, Button } from "react-bootstrap"
import { DeleteForeverRounded } from '@mui/icons-material'

import { getTranslation } from 'utils/renderLanguage'

const language = localStorage.getItem( 'english' )
const fieldData = [
  { label: getTranslation( language, 'Disbursement' ), value: 'disbursement_title', type: 'text', disabled: true },
  { label: getTranslation( language, 'Amount(RM)' ), value: 'amount', type: 'number', disabled: true },
  { label: getTranslation( language, 'Funding(%)' ), value: 'funding', type: 'number', disabled: true },
  { label: getTranslation( language, 'Date of Disbursement' ), value: 'disbursement_date', type: 'date' },
  { label: getTranslation( language, 'Project Completion(%)' ), value: 'project_completion', type: 'number' },
  { label: getTranslation( language, 'Support Document' ), value: 'disbursement_file', type: 'file' },
]

const DisbursementForm = props => {

  const [ disbursement, setDisbursement ] = useState({
    disbursement_title: '',
    funding: '',
    amount: '',
    project_completion: '',
    disbursement_date: '',
    disbursement_file: '',
    project_id: props.projectDetail.project_id,
  })

  useEffect( () => {
    if( props.selectedDisbursement && props.mode === 'update' ){
      setDisbursement( props.selectedDisbursement )
    }
  }, [] )

  const submitDisable = () => {
    if( props.mode === 'create' ){
      return !disbursement.disbursement_file
    } else {
      return !disbursement.disbursement_file_url && !disbursement.disbursement_file
    }
  }
  const handleSubmit = () => {
    console.log({ disbursement })
    console.log({ mode: props.mode })
    if( props.mode === 'create' )
      props.createDisbursement( disbursement )
    else 
      props.updateDisbursement( disbursement )
  }

  const onChangeField = ( val, context ) => {
    let temp = _.cloneDeep( disbursement )
    temp[ context ] = val
    setDisbursement( temp )
  }

  const onUploadFile = ( event, context ) => {
    if( event.target.files && event.target.files.length > 0 ) {
      let files = event.target.files
      const file = files[0]
      
      // Check file size (50MB limit)
      const maxSize = 50 * 1024 * 1024
      if( file.size > maxSize ) {
        alert(`File size exceeds 50MB limit. Please upload a smaller file. Current size: ${(file.size / (1024 * 1024)).toFixed(2)}MB`)
        event.target.value = null
        return
      }
      
      Object.keys( event.target.files ).map((key) => {
        let reader = new FileReader()
        reader.onload = (e) => {
          let tmp = {
            snapshot: e.target.result,
            snapshot_file_name: files[key] ? files[key].name : 'disbursement',
          }
          // Clear old file URL when uploading new file
          let temp = _.cloneDeep( disbursement )
          temp[ context ] = tmp
          temp.disbursement_file_url = ''
          temp.disbursement_file_name = ''
          setDisbursement( temp )
        }
        reader.readAsDataURL(event.target.files[key])
      })
    }
  }

  return(
    <Modal show={ true } onHide={() => props.setOpen(false)} size="xl" >
      <Modal.Header closeButton>
        <Modal.Title>{ props.title }</Modal.Title>
      </Modal.Header>
      <Modal.Body className='row'>
        {
          fieldData.map(( item, index ) => {
            if( item.type === 'file' ){
              return(
                <Form.Group key={ index } className='mt-3 col-lg-6' style={{ marginRight: 5 }}>
                  <Form.Label>{ item.label }</Form.Label>
                  {
                    ( disbursement.disbursement_file_url || disbursement[ item.value ] ) && (
                      <div className='project-detail__detail-cont d-flex align-items-center' style={{ padding: '10px 20px' }}>
                        <ImFilePdf style={{ width: 40, height: 40, color: 'red' }}/>
                        <div style={{ marginLeft: 10 }}>
                          <label>{ getTranslation( language, 'File Name' ) }</label>
                          <p className='m-0' >
                            { 
                              disbursement.disbursement_file_url
                                ? disbursement.disbursement_file_name
                                : disbursement[ item.value ].snapshot_file_name
                            }
                          </p>
                        </div>
                        <button
                          className={ 'btn btn-danger ml-auto' }
                          onClick={ () => {
                            if( disbursement.disbursement_file_url ){
                              let temp = _.cloneDeep( disbursement )
                              temp.disbursement_file_url = ''
                              temp.disbursement_file_name = ''
                              setDisbursement( temp )
                            } else {
                              onChangeField( '', 'disbursement_file' )
                            }
                          }}
                        >
                          <DeleteForeverRounded />
                        </button>
                      </div>
                    )
                  }
                  {
                    ( !disbursement.disbursement_file_url && !disbursement[ item.value ] ) && (
                      <Form.Control
                        type={ 'file' }
                        style={{ height: 'fit-content' }}
                        accept={ 'application/pdf' }
                        onChange={ event => onUploadFile( event, item.value ) }
                      />
                    )
                  }
                </Form.Group>
              )
            } else {
              return(
                <Form.Group key={ index } className='mt-3 col-lg-6'>
                  <Form.Label>{ item.label }</Form.Label>
                  <Form.Control
                    type={ item.type }
                    placeholder={ item.label }
                    disabled={ item.disabled }
                    value={ disbursement[ item.value ] }
                    onChange={ e => onChangeField( e.target.value, item.value ) }
                  />
                </Form.Group>
              )
            }
          })
        }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-danger" onClick={() => props.setOpen( false ) } >
          { getTranslation( language, 'Close' ) }
        </Button>
        <Button
          variant="primary"
          disabled={ submitDisable() } 
          onClick={ handleSubmit } >
          { getTranslation( language, 'Submit' ) }
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DisbursementForm;